export const selectedTopology = 'TOPOLOGY_UUID';

export const SET_EXECUTION_META_DATA_REQUEST = 'SET_EXECUTION_META_DATA_REQUEST';
export const SET_EXECUTION_META_DATA_SUCCESS = 'SET_EXECUTION_META_DATA_SUCCESS';
export const SET_EXECUTION_META_DATA_ERROR = 'SET_EXECUTION_META_DATA_ERROR';
